﻿(function (p, $, document) {

    var youChoose = 'js-you-choose',
        weChoose = 'js-we-choose',
        sharedChoose = 'js-shared-choose';

    var $modal = $('#js-cellar-circle-modal');
    var customerNo = $('.pnlChoiceWrap').attr('data-id');

    p.showResultModal = function (content) {
        if ($modal.length) {
            $modal
                .find('.js-content')
                .html(content)
                .foundation('reveal', 'open')
            ;
        } else {
            $('.cellar-circle-modal')
                .find('.js-content')
                .html(content)
            ;
            document.ShowModal(document.querySelector('.cellar-circle-modal'));
        }
    };

    p.bindPlan = function (id, plan) {
        $('#' + id + ' .js-activator, .' + id + '.js-activator' ).click(function (e) {
            e.preventDefault();

            p.unselectAllPlans();
            p.selectPlan(id);

            $.ajax({
                url: "/api/User/ChangePlan",
                method: 'POST',
                contentType: "application/json",
                dataType: "json",
                data: "{ 'customerNo': '" + customerNo + "', 'plan': '" + plan + "'}",
                success: function (msg) {
                    if (msg == true) {
                        p.showResultModal('Your membership type has been updated');
                    } else {
                        p.showResultModal('Sorry an error occurred. Please try reloading the page and repeater your action or call us on 01473 313 300');
                    }
                }
            });
        });
    }

    p.unselectAllPlans = function () {
        $('#js-you-choose, #js-we-choose, #js-shared-choose').removeClass('active');
        $('.js-you-choose, .js-we-choose, .js-shared-choose').removeClass('active');
        $('.js-choice').html('SELECT');
    }

    p.selectPlan = function (id) {
        $('#' + id).addClass('active');
        $('.' + id).addClass('active');
        $('#' + id).find('.js-choice').html('SELECTED');
    }

    $(document).ready(function () {
        p.bindPlan(youChoose, 'YOUBUY');
        p.bindPlan(weChoose, 'WEBUY');
        p.bindPlan(sharedChoose, 'SHARED');

        var currentPlan = $('.pnlChoiceWrap').attr('data-plan-name');


        if (currentPlan == 'YOUBUY') {
            p.selectPlan(youChoose);
        }
        else if (currentPlan == 'WEBUY') {
            p.selectPlan(weChoose);
        }
        else if (currentPlan == 'SHARED') {
            p.selectPlan(sharedChoose);
        }
    });

})(Crafted.Plugins, jQuery, document);